<style lang="scss" scoped>
.page-container {
  height: calc(100vh - 350px);

  .content-container {
    margin: 0 auto;

    .not-found {
      font-size: 6rem !important;
    }

    .main-text {
      margin-top: 32px;
      margin-bottom: 36px;
    }
  }
}
</style>

<template>
  <v-container class="page-container text-center" fill-height>
    <v-card class="content-container">
      <v-card-text class="pa-10">
        <h1 class="display-3 primary--text not-found">404</h1>
        <h2 class="display-2 font-weight-thin main-text">
          <div class="mb-4">Sorry, it appears the page you were looking for</div>
          <div>does not exist or may have moved.</div>
        </h2>
        <v-btn
          color="primary"
          :to="{ name: 'HomeView' }"
        >
          {{ `RETURN TO ${user ? 'HOME' : 'LOGIN'}` }}
        </v-btn>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: 'NotFound',
  computed: {
    user: vm => vm.$store.getters.user,
  },
};
</script>
